import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CfetBaseComponent } from '../../../cfet-core';

@Component({
    selector: 'app-customer-verification-pending',
    templateUrl: './customer-verification-pending.component.html',
    styleUrls: ['./customer-verification-pending.component.scss'],
    standalone: false
})
export class CustomerVerificationPendingComponent extends CfetBaseComponent implements OnInit {

  constructor() { super(); }
  @Output() goToDocUpload = new EventEmitter<any>();

  ngOnInit() {
    window.scrollTo(0, 0);
  }

  continueToDocUpload(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.goToDocUpload.emit(true);
    }
  }

}
